module.exports = __webpack_public_path__ + "img/70401684220773_.pic.9195cef9.jpg";